import { render, staticRenderFns } from "./f-header.vue?vue&type=template&id=d65f46b0&scoped=true&"
import script from "./f-header.vue?vue&type=script&lang=js&"
export * from "./f-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65f46b0",
  null
  
)

export default component.exports